<div class="main-right-content">
  <div class="manageUser">

    <div class="d-flex flex-column align-items-center justify-content-center py-5">

      <div *ngIf="isLoading" class="spinner-border text-success mb-4" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Loading...</span>
      </div>

      <h3 class="mb-3 text-center" [ngClass]="{
          'text-success': !isLoading && title === 'Request Processed Successfully',
          'text-danger': !isLoading && (title === 'Unable to Process Request' || title === 'Invalid Request')
        }">
        {{ title }}
      </h3>

      <p class="text-muted text-center">
        {{ message }}
      </p>

    </div>

  </div>
</div>

<ng-template #moreInfoModal>
  <div class="modal-header">
    <h4 class="modal-title">Request More Information</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      [disabled]="isSubmittingMoreInfo"
      (click)="cancelMoreInfo()"
    ></button>
  </div>

  <form>
    <div class="modal-body">
      <div class="form-group">
        <label for="moreInfo" class="form-label">Information required</label>
        <textarea
          id="moreInfo"
          name="moreInfo"
          class="form-control"
          rows="2"
          maxlength="2000"
          required
          autofocus
          [(ngModel)]="moreInfo"
          [disabled]="isSubmittingMoreInfo"
          [class.is-invalid]="moreInfoError"
          (ngModelChange)="moreInfoError = ''"
          appInputMaxLength="500"
        ></textarea>
        <div class="invalid-feedback" *ngIf="moreInfoError">
          {{ moreInfoError }}
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="isSubmittingMoreInfo"
        (click)="cancelMoreInfo()"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="isSubmittingMoreInfo"
        (click)="submitMoreInfo()"
      >
        {{ isSubmittingMoreInfo ? "Sending..." : "Send Request" }}
      </button>
    </div>
  </form>
</ng-template>
